<template>
  <div class="room air-station" v-loading="loading">
    <refresh-block @refreshData="refreshData"></refresh-block>
    <div class="air-left">
      <div class="air-diagram">
        <history-data :statusClass="diagramStatus" title="出口湿度实时曲线 (%) RH"
                      :legendData="diagramLegendData"
                      :series="diagramSeries">
        </history-data>
      </div>
      <div class="air-switch">
        <div class="air-switch-warp">
          <div class="switch-item">
            <switch-status title="除湿机启动" :series="switchStatus1"></switch-status>
          </div>
          <div class="switch-item">
            <switch-status title="预热指示" :series="switchStatus2"></switch-status>
          </div>
          <div class="switch-item">
            <switch-status title="一级加热指示" :series="switchStatus3"></switch-status>
          </div>
          <div class="switch-item">
            <switch-status title="二级加热指示" :series="switchStatus4"></switch-status>
          </div>
          <div class="switch-item">
            <switch-status title="再生风机指示再" :series="switchStatus5"></switch-status>
          </div>
          <div class="switch-item">
            <switch-status title="轮转马达指示轮" :series="switchStatus6"></switch-status>
          </div>
        </div>
        <div class="air-switch-warp air-bg" :class="pressureClass">
          <single-histogram :opts="singleHisOpts" :series="pressure"></single-histogram>
        </div>
      </div>
    </div>
    <div class="air-right">
      <div class="air-right-warp">
        <div class="exit-temp air-bg">
          <single-pie-histogram-wrap :opts="SinglePieHistogramWrapOpts1" :class="warningFlag1"
                                     :series="SinglePieHistogramWrapData1"></single-pie-histogram-wrap>
        </div>
        <div class="air-time">
          <RunningTimeBig title="运行时间" :series="runningTime"></RunningTimeBig>
        </div>
      </div>

      <div class="air-right-warp air-bg" :class="[statusClass1]">
        <single-solid-pie :opts="SingleSolidPieOpts3"
                          :series="SingleSolidPieData3"></single-solid-pie>
      </div>
      <div class="air-right-warp air-bg" :class="[statusClass3]">
        <single-solid-pie :opts="SingleSolidPieOpts1"
                          :series="SingleSolidPieData1"></single-solid-pie>
      </div>
      <div class="air-right-warp air-bg" :class="[statusClass2]">
        <single-solid-pie :opts="SingleSolidPieOpts2"
                          :series="SingleSolidPieData2"></single-solid-pie>
      </div>
    </div>
  </div>
</template>
<script>
  import airStationOneJson from './airStationOne.json'

  export default {
    name: 'airStation',
    data() {
      return {
        loading: false,
        singleHisOpts: { title: '再生温度', histogramName1: 'T', max: 200, sign: '°C' },
        pressure: {},
        pressureClass: '',
        warningFlag1: '',
        SinglePieHistogramWrapData1: {},
        SinglePieHistogramWrapOpts1: {
          title: '出口温湿度',
          histogramName1: 'T',
          center1: ['50%', '60%'],
          radius1: ['46%', '70%'],
          pieName1: 'RH',
          max: 80,
          pieMax: 100,
          toprichFontSize: 18,
          topFontSize: 20,
          sign: '°C'
        },
        diagramLegendData: ['湿度1'],
        diagramSeries: [],
        diagramStatus: '',
        runningTime: '',
        switchStatus1: { data: 0, isError: 'Normal' },
        switchStatus2: { data: 1, isError: 'Normal' },
        switchStatus3: { data: 0, isError: 'Normal' },
        switchStatus4: { data: 1, isError: 'Normal' },
        switchStatus5: { data: 1, isError: 'Normal' },
        switchStatus6: { data: 1, isError: 'Normal' },
        statusClass1: '',
        statusClass2: '',
        statusClass3: '',
        SingleSolidPieOpts1: { title: '初效过滤压差', max: 500 },
        SingleSolidPieOpts2: { title: '中效过滤压差', max: 500 },
        SingleSolidPieOpts3: { title: '高效过滤压差', max: 500 },
        SingleSolidPieData1: {},
        SingleSolidPieData2: {},
        SingleSolidPieData3: {},
        stationList: {
          airStationFive: '3623a806-57de-4c36-bfc0-b1cddffaebb9', // 5#制备站
          airStationSix: '01f14fb5-bd4d-4efd-b333-8a3aa2115f89' // 6#制备站
        },
        timeFunc: null
      }
    },
    watch: {
      /**
       * 监听路由变化
       * @param {Object} route # 当前路由信息
       */
      '$route'(route) {
        this.initData(route)
      }
    },
    created() {
      this.initData(this.$route)
      this.timeFunc = setInterval(() => {
        this.initData(this.$route)
      }, this.REFRESH_SECOND)
    },
    destroyed() {
      clearInterval(this.timeFunc)
      this.timeFunc = null
    },
    methods: {
      /**
       * 加载数据
       * @param {Object} route # 当前路由信息
       */
      initData({ name }) {
        this.loading = true
        const deviceList = airStationOneJson[name]
        const oneHttp = this.$http.get(`/deviceData/Station?stationId=${this.stationList[name]}&interval=BY_HOUR`)
        const twoHttp = this.$http.get(`/statistics/DeviceData?deviceId=${deviceList[9].deviceId}&interval=BY_HOUR&insertBlankData=true`)
        this.$http.all([oneHttp, twoHttp])
          .then(this.$http.spread(({ data = {} }, res2) => {
            this.$store.commit('setLastRefreshTime')
            this.loading = false
            this.diagramStatus = res2.data.errorLevel
            const aryOne = {}
            res2.data.dataList.forEach(val => {
              aryOne[val.StatisticsDate] = val.value
            })
            this.diagramSeries = [aryOne]
            this.switchStatus1 = {
              data: data[deviceList[0].deviceId].value,
              isError: data[deviceList[0].deviceId].errorLevel
            }
            this.switchStatus2 = {
              data: data[deviceList[3].deviceId].value,
              isError: data[deviceList[3].deviceId].errorLevel
            }
            this.switchStatus3 = {
              data: data[deviceList[4].deviceId].value,
              isError: data[deviceList[4].deviceId].errorLevel
            }
            this.switchStatus4 = {
              data: data[deviceList[5].deviceId].value,
              isError: data[deviceList[5].deviceId].errorLevel
            }
            this.switchStatus5 = {
              data: data[deviceList[6].deviceId].value,
              isError: data[deviceList[6].deviceId].errorLevel
            }
            this.switchStatus6 = {
              data: data[deviceList[7].deviceId].value,
              isError: data[deviceList[7].deviceId].errorLevel
            }
            this.pressure = { data: data[deviceList[1].deviceId].value }
            this.pressureClass = data[deviceList[1].deviceId].errorLevel
            this.runningTime = data[deviceList[2].deviceId].value
            this.SinglePieHistogramWrapData1 = {
              data1: data[deviceList[8].deviceId].value,
              data2: data[deviceList[9].deviceId].value
            }
            this.warningFlag1 = data[deviceList[8].deviceId].errorLevel
            if (data[deviceList[9].deviceId].errorLevel === 'Error') this.warningFlag1 = 'Error'
            this.SingleSolidPieData1 = { data1: data[deviceList[10].deviceId].value }
            this.statusClass1 = data[deviceList[10].deviceId].errorLevel
            this.SingleSolidPieData2 = { data1: data[deviceList[11].deviceId].value }
            this.statusClass2 = data[deviceList[11].deviceId].errorLevel
            this.SingleSolidPieData3 = { data1: data[deviceList[12].deviceId].value }
            this.statusClass3 = data[deviceList[12].deviceId].errorLevel
          }))
      },
      refreshData() {
        this.initData(this.$route)
        clearInterval(this.timeFunc)
        this.timeFunc = setInterval(() => {
          this.initData(this.$route)
        }, this.REFRESH_SECOND)
      },
      getData() {
        if (!this.loading) this.initData(this.$route)
      }
    }
  }
</script>
<style lang="scss">
  .air-station {
    .graph-wrapper {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>
<style lang="scss" scoped>
  .temp-warp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(255, 255, 255, 0.6);
    padding: 20px 0 50px;
    box-sizing: border-box;
    position: relative;

    .temp-title {
      position: absolute;
      top: 10px;
      left: 10px;
    }
  }

  .temp-tt {
    height: 60%;
    width: 40%;
  }

  .air-station {
    display: flex;
    flex-direction: row;
    min-height: 530px;
    overflow: hidden;
    padding: 10px 0 30px;
    box-sizing: border-box;
    justify-content: space-between;
  }

  .air-left {
    width: calc(50% - 10px);
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
  }

  .air-diagram {
    width: 100%;
    height: calc(50% - 10px);
    background-color: rgba(255, 255, 255, 0.6);
  }

  .air-switch {
    height: calc(50% - 10px);
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .air-switch-warp {
    width: calc(50% - 10px);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .air-bg {
    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 42px;
    width: 100%;
  }

  .ari-running-time {
    width: 100%;
    height: 112px;
  }

  .temp-warp {
    width: 100%;
    height: calc(100% - 142px);
  }

  .air-right {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
  }

  .air-time {
    height: 86px;
    width: 100%;
  }

  .exit-temp {
    height: calc(100% - 96px);
  }

  .air-right-warp {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
    width: calc(50% - 10px);
    height: calc(50% - 10px);
  }
</style>
